export const HIGHLIGHTED_SPAN_WRAPPER_ID = 'highlight-wrapper';

export const ALLOWED_TAGS = [
  'p',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'div',
  'pre',
  'blockquote',
  'section',
  'article',
  'span',
  'strong',
  'em',
  'u',
  's',
  'sub',
  'sup',
  'code',
  'ul',
  'ol',
  'li',
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
  'img',
  'audio',
  'video',
  'iframe',
  'a',
  'br',
  'hr',
  'b',
  'i',
];
